var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6738 14.1669L5.38252 16.7186L2.81152 28.2446L9.89352 25.4526L17.0245 28.2446L24.0575 25.4526L31.1885 28.2896L28.6175 16.5836L22.4238 14.1669",
    stroke: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2625 14.4226L9.85547 25.4526",
    stroke: "#E2E8F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7588 14.3326L24.0198 25.4526",
    stroke: "#E2E8F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0246 21.6981L17.0244 28.2446",
    stroke: "#E2E8F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6479 12.0458C22.6479 15.4708 17.0239 21.8138 17.0239 21.8138C17.0239 21.8138 11.4009 15.4708 11.4009 12.0458C11.3285 10.479 11.8793 8.94735 12.933 7.78555C13.9867 6.62375 15.4575 5.92636 17.0239 5.84583C18.5904 5.9261 20.0614 6.62337 21.1153 7.7852C22.1692 8.94703 22.7202 10.4789 22.6479 12.0458V12.0458Z",
    stroke: "#E2E8F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0283 14.3178C18.409 14.3178 19.5283 13.1985 19.5283 11.8178C19.5283 10.4371 18.409 9.31781 17.0283 9.31781C15.6476 9.31781 14.5283 10.4371 14.5283 11.8178C14.5283 13.1985 15.6476 14.3178 17.0283 14.3178Z",
    stroke: "#E2E8F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSearch);
export default __webpack_public_path__ + "static/media/MapSearch.6f9e823b.svg";
export { ForwardRef as ReactComponent };